import { render } from "./DetailedContactDialog.vue?vue&type=template&id=21f751cf&scoped=true"
import script from "./DetailedContactDialog.vue?vue&type=script&lang=js"
export * from "./DetailedContactDialog.vue?vue&type=script&lang=js"

import "./DetailedContactDialog.vue?vue&type=style&index=0&id=21f751cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f751cf"]])

export default __exports__